import React from 'react'

import {
    StyledJanus,
    StyledGridItem,
    JanusBreakpointOptions,
} from '../../compositions/Janus/Janus.styled'
import { ThemeMargins } from '../../__styling/settings/metrics'

export type JanusLayoutRatio = '1:1' | '3:1' | '1:3' | '2:3'

export interface JanusProps {
    content: [React.ReactElement<any>, React.ReactElement<any>]
    hasBackgroundFill?: boolean
    verticalSpacing?: keyof ThemeMargins
    layoutRatio?: JanusLayoutRatio
    breakpoints?: JanusBreakpointOptions
}

export const Janus: React.FC<JanusProps> = ({
    content,
    verticalSpacing,
    hasBackgroundFill,
    layoutRatio = '1:1',
    breakpoints,
}) => (
    <StyledJanus
        hasBackgroundFill={hasBackgroundFill}
        verticalSpacing={verticalSpacing}
        layoutRatio={layoutRatio}
        breakpoints={breakpoints}
    >
        <StyledGridItem>{content[0]}</StyledGridItem>
        <StyledGridItem>{content[1]}</StyledGridItem>
    </StyledJanus>
)
Janus.displayName = 'Janus'
